import { useEffect, useState } from 'react';
import { FloatingLabel, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { PutAnalysisObservation } from '../../../API/AnalysisAPI';
import './styles.css';

interface ObservationComponentProps {
    observation: string, 
    analysisId: string,
    toggleLoading: (data: boolean) => void,
    canNotEdit: boolean,
    userEmail: string,
    companyId: string,
    hasConcluded: boolean
}

const ObservationComponent = (props: ObservationComponentProps) => {
    const [text, setText] = useState<string>("");
    const [def, setDef] = useState<string>("");

    const UpdateObservation = async () => {
        if (text == props.observation) return;
        try {
            props.toggleLoading(true);
            await PutAnalysisObservation(props.analysisId, text, props.userEmail, props.companyId).finally(() => {
                props.toggleLoading(false);
            });
        } catch (error: any) {
            props.toggleLoading(false);
            toast.error(error.message);
        }
    }

    useEffect(() => {
        setText(props.observation);
        setDef(props.observation);
    }, [props.observation]);

    return (
        <div className='pagination-tab-body d-flex flex-column mt-4'>
            <span className='text-center mb-2'><b>Observação da Análise</b></span>
            {props.observation == def &&
                <FloatingLabel label="" className="mb-3">
                    <Form.Control disabled={props.canNotEdit || props.hasConcluded} as="textarea" id="input-text-area" value={text != null ? text : ""} onBlur={UpdateObservation} onChange={(e: any) => setText(e.target.value)} />
                </FloatingLabel>
            }
        </div>
    )
}

export default ObservationComponent;